import React from 'react';
import PropTypes from 'prop-types';
import { gql, graphql } from 'react-apollo';
import { StyleSheet, css } from 'aphrodite';
import { connect } from 'react-redux';
import { IconButton } from 'material-ui';
import Add from 'material-ui/svg-icons/content/add';

import * as InquiryActions from '../../store/actions/InquiryActions';

const SuggestedTravelersQuery = gql`
query SuggestedTravelersQuery($travelers: [String]!) {
  allTravelers(travelers: $travelers) {
    edges {
      node {
        id,
        firstName,
        lastName,
        fullName,
        displayName,
        email,
        birthdate,
        adult,
        isPrimaryTraveler,
        primaryTraveler {
          id
        },
        primaryTravelerName,
        insideCircle,
        needsTraining,
        needsVetting,
        fullName,
      }
    }
  }
}
`;

@connect()
@graphql(SuggestedTravelersQuery)
class SuggestedTravelers extends React.Component {
  static propTypes = {
    data: PropTypes.shape().isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      foo: 'bar',
    };
  }

  travelerSelected = selected => () => {
    const {
      id, firstName, lastName, fullName, displayName, email, birthdate,
      adult: isAdult, isPrimaryTraveler, primaryTraveler, primaryTravelerName,
      insideCircle, needsTraining, needsVetting,
    } = selected;

    const traveler = {
      id,
      firstName,
      lastName,
      fullName,
      displayName,
      email,
      birthdate,
      isAdult,
      isPrimaryTraveler,
      primaryTravelerId: primaryTraveler ? primaryTraveler.id : '',
      primaryTravelerName,
      insideCircle,
      needsTraining,
      needsVetting,
    };

    this.props.dispatch(InquiryActions.addTraveler(traveler));
  }

  content = () => {
    if (this.props.data.loading) {
      return <div>Loading…</div>;
    }

    const { data: { allTravelers: { edges: trips } } } = this.props;

    return (<div>
      <ul>
        {trips.map(({ node: traveler }) => (
          <li key={traveler.id} className={css(styles.listItem)}>
            {traveler.displayName || traveler.fullName}
            <IconButton
              onTouchTap={this.travelerSelected(traveler)}
              className={css(styles.buttonStyle)}
            >
              <Add />
            </IconButton>
          </li>
        ))}
      </ul>
    </div>);
  }

  render() {
    return (<div className={css(styles.container)}>
      <h2>Suggested travelers:</h2>
      {this.content()}
    </div>);
  }
}

const styles = StyleSheet.create({
  container: {
    marginRight: 15,
    marginLeft: 15,
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5,
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
});

export default SuggestedTravelers;



// WEBPACK FOOTER //
// /src/components/Inquiry/SuggestedTravelers.js